import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Card } from 'components';
import { routes } from 'router';

import beach from 'assets/img/beach.jpg';
import 'assets/styles/components/pages/not-found.scss';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="rounded-3xl overflow-hidden relative not-found-container">
      <Card className="not-found-card">
        <h1 className="text-xl text-center uppercase font-semibold" data-test-id="notFoundTitle">
          <span className="block">{t('notFound.content')}</span>
          <span className="block">{t('notFound.title')}</span>
        </h1>
        <div>
          <Trans i18nKey="help" className="text-center">
            <a href="tel:0144064545" className="underline hover:no-underline">
              01 44 06 45 45
            </a>
          </Trans>
        </div>

        <Link to={routes.home.path} className="btn w-fit mx-auto">
          {t('buttons.goBackHome')}
        </Link>
      </Card>

      <img src={beach} className="w-full h-full object-cover" alt="" width="700" height="394" />
    </div>
  );
};

export default NotFoundPage;
